import {createParentPositions} from "../../constants";
import AccessoryCommon from "./accessoryCommon";

export default class LargeCornerCaddie extends AccessoryCommon {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'large_corner_caddie';
    this.partName = 'Large Corner Caddie';
    this.translateId = "visualizer.bathroom.accessories.large_corner_caddie";
    this.visible = true;
    this.canBeDisabled = true;
    if (isChild) {
      createParentPositions(this);
    }
  }

  handleClick() {
    const accessoriesParent = this.getParent().getParent();
    accessoriesParent.caddie_type = this.partId;
    super.handleClick();
  }

  setLayers(layout) {

    const accessoriesParent = this.getParent();
    if (accessoriesParent.caddie_type !== this.partId) {
      super.hideLayers();
      return;
    }

    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions()))) {
      // this.checkIfFeaturePartIsMatching();
      return super.setLayers(layout);
    }

    this.setDefault();
    return super.setLayers(layout);
  }

  // setZIndex(zIndexes) {
  //   if (zIndexes) {
  //     Object.keys(this.layerPositions).forEach((key, keyIndex) => {
  //       if (this.layerPositions[key]) {
  //         this.layerPositions[key].layer.zIndex = zIndexes.Accessories.LargeCornerCaddie + keyIndex*10;
  //       }
  //     })
  //   }
  // }

}
